import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { authLogin } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Shell, Card, H1, Field, Btn } from "./ui";

export default function Login() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authLogin(email, password);
      const u = await refresh();
      toast.success("Signed in");
      nav(u?.platform_role ? "/platform" : "/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password");
    } finally { setBusy(false); }
  };

  return (
    <Shell>
      <div className="max-w-md mx-auto mt-16">
        <div className="mb-6 text-[#00D26A] text-xs tracking-[0.3em] uppercase">Turf Designer Platform</div>
        <H1>Sign in</H1>
        <Card className="mt-6">
          <form onSubmit={submit} data-testid="login-form">
            <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
            <Field label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
            <Btn type="submit" disabled={busy} data-testid="login-submit" className="w-full mt-2">{busy ? "Signing in…" : "Sign in"}</Btn>
          </form>
          <div className="flex justify-between mt-4 text-xs text-white/50">
            <Link to="/forgot" className="hover:text-[#00D26A]" data-testid="login-forgot-link">Forgot password?</Link>
            <Link to="/signup" className="hover:text-[#00D26A]" data-testid="login-signup-link">Create an account</Link>
          </div>
        </Card>
      </div>
    </Shell>
  );
}
